<template>
  <div class="d-flex">
    <div class="width-50-perc bordered-gray">
      <v-data-table
        v-model="itensAdicionarSelecionados"
        :headers="headersItensNaoSalvos"
        :items="itensFiltrados"
        :search="pesquisaItens"
        height="calc(100vh - 185px)"
        class="table-full-screen"
        item-key="idcategoria"
        :items-per-page="-1"
        hide-default-footer
        fixed-header
        show-select
        dense
      >
        <template v-slot:top>
          <div class="d-flex my-3 px-2">
            <p class="ma-0 subtitle-2">{{itensFiltrados.length}} Categorias de Distribuição</p>

            <v-spacer />

            <v-text-field
              v-model="pesquisaItens"
              placeholder="Pesquisar"
              hide-details
              append-icon="mdi-magnify"
              dense
              height="25"
              style="max-width: 350px"
              class="mt-n1"
            ></v-text-field>
          </div>
        </template>

        <template v-slot:item.acoes="{item}">
          <v-btn icon @click="addItens([item])">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>

    <div style="width: 90px" class="d-flex align-center justify-center">
      <div id="div-icones-add-ou-remove">
        <v-badge bordered color="white" overlap offset-x="45">
          <template v-slot:badge>
            <span style="color: #000000">{{itensAdicionarSelecionados.length}}</span>
          </template>

          <v-btn icon outlined @click="addItens(itensAdicionarSelecionados)">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-badge>

        <br />

        <v-badge bordered color="white" overlap class="mt-6">
          <template v-slot:badge>
            <span style="color: #000000">{{itensRemoverSelecionados.length}}</span>
          </template>

          <v-btn icon outlined @click="removeItens(itensRemoverSelecionados)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-badge>
      </div>
    </div>

    <div class="width-50-perc bordered-gray">
      <v-data-table
        v-model="itensRemoverSelecionados"
        :headers="headersItensSalvos"
        :items="categoriasCadastradas"
        :search="pesquisaItensCadastrados"
        height="calc(100vh - 185px)"
        class="table-full-screen"
        item-key="id"
        :items-per-page="-1"
        hide-default-footer
        fixed-header
        show-select
        dense
      >
        <template v-slot:top>
          <div class="d-flex my-3 px-2">
            <p class="ma-0 subtitle-2">{{categoriasCadastradas.length}} Categorias Salvas</p>

            <v-spacer />

            <v-text-field
              v-model="pesquisaItensCadastrados"
              placeholder="Pesquisar"
              hide-details
              append-icon="mdi-magnify"
              dense
              height="25"
              style="max-width: 350px"
              class="mt-n1"
            ></v-text-field>
          </div>
        </template>

        <template v-slot:item.acoes="{item}">
          <v-btn icon @click="removeItens([item])">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import FilialAPI from "../../../api/filial"

export default {
  name: "ListaDeCategoriasFiltradas",
  props: {
    filiais: {
      type: Array,
      required: true
    },
    familiais: {
      type: Array,
      required: true
    },
    itens: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    headersItensNaoSalvos: [
      {text: "", value: 'data-table-select', width: '5px'},
      {text: "Id", value: 'idcategoria'},
      {text: "Descrição da Categoria", value: 'descricao'},
      {text: "Ações", value: 'acoes', width: '5px', sortable: false},
    ],
    headersItensSalvos: [
      {text: "Ações", value: 'acoes', width: '5px', sortable: false},
      {text: "", value: 'data-table-select', width: '5px'},
      {text: "Filial", value: 'filial'},
      {text: "Família", value: 'familia'},
      {text: "Id da categoria", value: 'idcategoria'},
      {text: "Descrição da Categoria", value: 'descricao'},
    ],
    categoriasCadastradas: [],
    itensAdicionarSelecionados: [],
    itensRemoverSelecionados: [],
    pesquisaItens: "",
    pesquisaItensCadastrados: ""
  }),
  computed: {
    buscaValida() {
      return this.familiais && this.familiais.length > 0 && this.filiais && this.filiais.length > 0
    },
    idsCategoriasSelecionadas() {
      return this.Helpers.arrayColumn(this.categoriasCadastradas, 'idcategoria')
    },
    itensFiltrados () {
      if (this.categoriasCadastradas.length === 0) {
        return this.itens
      }

      return this.itens.filter(item => !this.idsCategoriasSelecionadas.includes(item.idcategoria))
    }
  },
  watch: {
    filiais () {
      this.getCategoriasMapeadas()
    },
    familiais () {
      this.getCategoriasMapeadas()
    },
    itens() {
      this.itensAdicionarSelecionados = []
    },
    buscaValida() {
      this.categoriasCadastradas = []
    }
  },
  mounted() {
    this.getCategoriasMapeadas()
  },
  methods: {
    atualizarTabelaFora() {
      this.$emit("updateTableDialogClosed", {})
    },
    getCategoriasMapeadas () {
      if (this.buscaValida) {
        const headers = this.Helpers.iniciarRequisicao()
        const params = {
          filiais: this.filiais,
          familiais: this.familiais
        }

        this.$store.dispatch("loading/addRequisicao",
          FilialAPI.getCategoriasMapeadas(headers, params)
            .then(response => {
              const {token, categorias } = response.data
              localStorage.token = token
              this.categoriasCadastradas = categorias
            })
            .catch(() => this.Helpers.logout())
        )
      }
    },
    addItens (itens) {
      if (itens.length === 0) {
        return
      }

      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        filiais: this.filiais,
        categorias: this.Helpers.arrayColumn(itens, 'idcategoria')
      }

      this.$store.dispatch("loading/addRequisicao",
        FilialAPI.setMapeamentoCategoriaDistribuicaoFilial(headers, params)
          .then(response => {
            localStorage.token = response.data.token
            this.itensAdicionarSelecionados = []
            this.getCategoriasMapeadas()
            this.atualizarTabelaFora()
          })
          .catch(() => this.Helpers.logout())
      )
    },
    removeItens (itens) {
      if (itens.length === 0) {
        return
      }

      const headers = this.Helpers.iniciarRequisicao()

      const ids = this.Helpers.arrayColumn(itens, 'id')

      this.$store.dispatch("loading/addRequisicao",
        FilialAPI.deleteItensMapeamentoDistribuicao(headers, {itens: ids})
          .then(response => {
            localStorage.token = response.data.token
            this.categoriasCadastradas = this.categoriasCadastradas.filter(item => !ids.includes(item.id))
            this.itensRemoverSelecionados = []
            this.atualizarTabelaFora()
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style scoped>
.width-50-perc {
  width: 50%;
}
#div-icones-add-ou-remove {
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 25px;
  background: rgba(0,0,0,.02);
  padding: 14px 10px 14px 10px;
}
.bordered-gray {
  border: 1px solid rgba(0,0,0,.1);
}
</style>
